import React from "react";
import { Link } from "react-router-dom";

function PrimayDarkBtn({ title, url, onClick }) {
  return (
    <Link
      onClick={onClick}
      to={url}
      className="btn bg-darken-primary-20 bg-darken-primary-20-btn text-white p-3 rounded-pill width-160"
    >
      {title}
    </Link>
  );
}

export default PrimayDarkBtn;
